import Base from '../../js/_base';
import 'configurable-date-input-polyfill';
import TableAccordion from '../../components/table-accordion/_table_accordion';
import ClientPagination from '../../components/client-pagination/_client-pagination';
let $document;

export default class PairingManagement extends Base {
    accTable;

    accTablePagination;

    get pageContext() {
        return encodeURI($("[name='pbContext']").attr('content'));
    }

    get widgetId() {
        return this.wrapper.dataset.widgetid;
    }

    get serviceName() {
        return this.wrapper.querySelector(this._selectors.serviceNameHidden).textContent;
    }

    get antiForgeryToken() {
        return this.wrapper.querySelector(this._selectors.antiForgeryToken).textContent;
    }

    get serverErrMsgPrefix() {
        return this.wrapper.dataset.serverErrorMsg;
    }

    get selectors() {
        return {
            accordionTable: '.accordion-table',
            addExternalEmailButton: '#addExternalEmailButton',
            addExternalEmailField: '#addExternalEmail',
            addExternalEmailExpField: '#addExternalEmailExp',
            addExternalEmailReasonField: '#addExternalEmailReason',
            serviceNameHidden: '.serviceNameHidden',
            antiForgeryToken: '.antiForgeryToken',
            refreshButton: '#refreshButton',
            widgetId: '#pairingManagmentWidgetId',
            externalEmailDialog: '#externalEmailDialogForm',
            extendReinstateAccessDialog: '#extendReinstateAccessDialogForm',
            revokeAccessDialog: '#revokeAccessDialogForm',
            externalEmailError: '#externalEmailError',
            extendReinstateEmailField: '#extendEmail',
            extendReinstateExpDaysField: '#extendEmailExp',
            extendReinstateReasonField: '#extendEmailReason',
            expDays: '.exp-days',
            emailFilterRadios: 'input[name=emailFilter]',
            permissionFilterRadios: 'input[name=permissionFilter]',
            checkedEmailFilterRadios: 'input[name=emailFilter]:checked',
            checkedPermissionFilterRadios: 'input[name=permissionFilter]:checked',
            emailAddressInput: 'input[name=emailAddress]',
            nameInput: 'input[name=name]',
            confirmAddExternalEmail: '#confirmAddExternalEmail',
            confirmExtendReinstate: '#confirmExtendReinstate',
            confirmRevokeAccess: '#confirmRevokeAccess',
            fromDateField: 'input[name=fromDate]',
            toDateField: 'input[name=toDate]',
            revokeEmailField: '#revokeAccessEmail',
            revokeReasonField: '#revokeAccessReason',
            extendReinstateButton: '#extendReinstateButton',
            revokeButton: '#revokeButton',
            viewDetailButton: '#viewDetailButton',
            withSelected: '.with-selected',
            viewDevicePairingDetailsForm: '#viewDevicePairingDetailsForm',
            invalidFeedback: '.invalid-feedback',
            fromDateFeedback: '#fromDateFeedback',
            toDateFeedback: '#toDateFeedback',
            userEmailRadio: 'input[name=userEmail]',
            checkedUserEmail: 'input[name=userEmail]:checked',
            dialogEmail: '.dialog-email',
            dialogExpire: '.dialog-expire',
            dialogReason: '.dialog-reason',
            pairingManagementPagination: '.pairing-management__pagination',
            dropdownItems: '.dropdown-item',
        };
    }

    get elements() {
        return {
            accordionTable: null,
            addExternalEmailField: null,
            addExternalEmailExpField: null,
            addExternalEmailReasonField: null,
            refreshButton: null,
            externalEmailDialog: null,
            extendReinstateAccessDialog: null,
            revokeAccessDialog: null,
            externalEmailError: null,
            expDays: null,
            emailFilterRadios: null,
            permissionFilterRadios: null,
            checkedEmailFilterRadios: null,
            checkedPermissionFilterRadios: null,
            emailAddressInput: null,
            nameInput: null,
            confirmAddExternalEmail: null,
            confirmExtendReinstate: null,
            confirmRevokeAccess: null,
            fromDateField: null,
            toDateField: null,
            revokeEmailField: null,
            revokeReasonField: null,
            extendReinstateButton: null,
            revokeButton: null,
            viewDetailButton: null,
            withSelected: null,
            viewDevicePairingDetailsForm: null,
            fromDateFeedback: null,
            toDateFeedback: null,
            userEmailRadio: null,
            checkedUserEmail: null,
            extendReinstateEmailField: null,
            dialogEmail: null,
            dialogExpire: null,
            dialogReason: null,
            pairingManagementPagination: null,
        };
    }

    get classList() {
        return {
            isInvalid: 'is-invalid',
        };
    }

    constructor(wrapper) {
        super();
        this.wrapper = wrapper;
        $document = $(document);
        this.initialize();
    }

    initialize() {
        super.initialize();
        this._pageContext = this.pageContext;
        this._widgetId = this.widgetId;
        this._serviceName = this.serviceName;
        this._antiForgeryToken = this.antiForgeryToken;
        this._serverErrMsgPrefix = this.serverErrMsgPrefix;
        this._elements.fromDateField = this.wrapper.querySelector(this._selectors.fromDateField);
        this._elements.toDateField = this.wrapper.querySelector(this._selectors.toDateField);
        this._elements.fromDateFeedback = this.wrapper.querySelector(this._selectors.fromDateFeedback);
        this._elements.toDateFeedback = this.wrapper.querySelector(this._selectors.toDateFeedback);
        this._elements.accordionTable = this.wrapper.querySelector(this._selectors.accordionTable);
        this._elements.refreshButton = this.wrapper.querySelector(this._selectors.refreshButton);
        this._elements.addExternalEmailButton = this.wrapper.querySelector(this._selectors.addExternalEmailButton);
        this._elements.emailFilterRadios = this.wrapper.querySelectorAll(this._selectors.emailFilterRadios);
        this._elements.permissionFilterRadios = this.wrapper.querySelectorAll(this._selectors.permissionFilterRadios);
        this._elements.emailAddressInput = this.wrapper.querySelector(this._selectors.emailAddressInput);
        this._elements.nameInput = this.wrapper.querySelector(this._selectors.nameInput);
        this._elements.confirmAddExternalEmail = this.wrapper.querySelector(this._selectors.confirmAddExternalEmail);
        this._elements.confirmExtendReinstate = this.wrapper.querySelector(this._selectors.confirmExtendReinstate);
        this._elements.confirmRevokeAccess = this.wrapper.querySelector(this._selectors.confirmRevokeAccess);
        this._elements.withSelected = this.wrapper.querySelector(this._selectors.withSelected);
        this._elements.extendReinstateButton = this.wrapper.querySelector(this._selectors.extendReinstateButton);
        this._elements.revokeButton = this.wrapper.querySelector(this._selectors.revokeButton);
        this._elements.viewDetailButton = this.wrapper.querySelector(this._selectors.viewDetailButton);
        this._elements.viewDevicePairingDetailsForm = this.wrapper.querySelector(
            this._selectors.viewDevicePairingDetailsForm
        );
        this._elements.userEmailRadio = this.wrapper.querySelectorAll(this._selectors.userEmailRadio);
        this._elements.revokeEmailField = this.wrapper.querySelector(this._selectors.revokeEmailField);
        this._elements.extendReinstateEmailField = this.wrapper.querySelector(
            this._selectors.extendReinstateEmailField
        );
        this._elements.dialogEmail = this.wrapper.querySelectorAll(this._selectors.dialogEmail);
        this._elements.dialogExpire = this.wrapper.querySelectorAll(this._selectors.dialogExpire);
        this._elements.dialogReason = this.wrapper.querySelectorAll(this._selectors.dialogReason);
        this._elements.pairingManagementPagination = this.wrapper.querySelector(
            this._selectors.pairingManagementPagination
        );
        this._elements.dropdownItems = this.wrapper.querySelectorAll(this._selectors.dropdownItems);
        // modals
        this._elements.externalEmailDialog = $(this._selectors.externalEmailDialog);
        this._elements.extendReinstateAccessDialog = $(this._selectors.extendReinstateAccessDialog);
        this._elements.revokeAccessDialog = $(this._selectors.revokeAccessDialog);
        this._elements.externalEmailError = $(this._selectors.externalEmailError);

        this.initAccordionTableInstance(this._elements.accordionTable, this._elements.pairingManagementPagination);
        this.initDatePickers();
        this.addEventListeners();
    }

    addEventListeners() {
        super.addEventListeners();
        this._elements.fromDateField.addEventListener('change', this.onFromDateChange.bind(this));
        this._elements.toDateField.addEventListener('change', this.onToDateChange.bind(this));
        this._elements.refreshButton.addEventListener('click', this.onRefreshClick.bind(this));
        this._elements.extendReinstateButton.addEventListener('click', this.onExtendReinstateButtonClick.bind(this));
        this._elements.revokeButton.addEventListener('click', this.onRevokeButtonClick.bind(this));
        this._elements.addExternalEmailButton.addEventListener('click', this.onAddExternalEmailClick.bind(this));
        this._elements.confirmAddExternalEmail.addEventListener(
            'click',
            this.onConfirmAddExternalEmailClick.bind(this)
        );
        this._elements.confirmExtendReinstate.addEventListener('click', this.onConfirmExtendReinstateClick.bind(this));
        this._elements.confirmRevokeAccess.addEventListener('click', this.onConfirmRevokeAccessClick.bind(this));
        this._elements.viewDetailButton.addEventListener('click', this.onViewDetailClick.bind(this));
        this._elements.viewDetailButton.addEventListener('click', this.onViewDetailClick.bind(this));
        this._elements.dropdownItems.forEach(item => {
            item.addEventListener('click', this.onDropDownClick.bind(this));
        });
        this._elements.userEmailRadio.forEach(email => {
            email.addEventListener('change', this.enableActionButtons.bind(this));
        });
        // Dialog Validations
        this._elements.dialogEmail.forEach(field => {
            field.addEventListener(
                'focusout',
                () => {
                    this.checkEmail(field);
                },
                false
            );
        });
        this._elements.dialogExpire.forEach(field => {
            field.addEventListener(
                'focusout',
                () => {
                    this.checkExpirationDays(field);
                },
                false
            );
        });
        this._elements.dialogReason.forEach(field => {
            field.addEventListener(
                'focusout',
                () => {
                    this.checkReason(field);
                },
                false
            );
        });
    }

    initAccordionTableInstance(table, pagination) {
        this.accTable = new TableAccordion($document, table);
        if (this.accTable) {
            this.accTable.initialize();
        }
        this.accTablePagination = new ClientPagination(table, pagination);
        if (this.accTablePagination) {
            this.accTablePagination.initialize();
        }
    }

    initDatePickers() {
        // set fromTo days before
        const daysBefore = 180;
        this._elements.fromDateField.valueAsDate = new Date(Date.now() - daysBefore * 24 * 60 * 60 * 1000);
        // set to today plus one
        this._elements.toDateField.valueAsDate = new Date(Date.now() + 24 * 60 * 60 * 1000);
        this._elements.fromDateField.setAttribute('max', this._elements.toDateField.value);
        this._elements.toDateField.setAttribute('min', this._elements.fromDateField.value);
    }

    // Listener Methods
    onDropDownClick(e) {
        setTimeout(() => {
            this._elements.withSelected.textContent = this._elements.withSelected.dataset.withSelectedCaption;
        });
    }

    onFromDateChange(e) {
        const value = e.target.value;
        this._elements.toDateField.setAttribute('min', value);
        this.checkDates();
    }

    onToDateChange(e) {
        const value = e.target.value;
        this._elements.fromDateField.setAttribute('max', value);
        this.checkDates();
    }

    onRefreshClick(e) {
        e.preventDefault();
        this.refreshPairedDevices();
    }

    onExtendReinstateButtonClick(e) {
        e.preventDefault();
        this.clearDialog(this._elements.extendReinstateAccessDialog);
        this._elements.extendReinstateEmailField.value = this._elements.checkedUserEmail.value;
    }

    onRevokeButtonClick(e) {
        e.preventDefault();
        this.clearDialog(this._elements.revokeAccessDialog);
        this._elements.revokeEmailField.value = this._elements.checkedUserEmail.value;
    }

    onAddExternalEmailClick(e) {
        e.preventDefault();
        this.clearDialog(this._elements.externalEmailDialog);
    }

    onConfirmAddExternalEmailClick(e) {
        e.preventDefault();
        this.addExternalEmail();
    }

    onConfirmExtendReinstateClick(e) {
        e.preventDefault();
        this.extendReinstateEmail();
    }

    onConfirmRevokeAccessClick(e) {
        e.preventDefault();
        this.revokeEmail();
    }

    onViewDetailClick(e) {
        e.preventDefault();
        const userEmail = this._elements.checkedUserEmail.getAttribute('id');
        let inputEl = document.createElement('input');
        inputEl.type = 'hidden';
        inputEl.name = 'userEmail';
        inputEl.value = userEmail;
        this._elements.viewDevicePairingDetailsForm.appendChild(inputEl);
        this._elements.viewDevicePairingDetailsForm.submit();
    }

    // Selected actions methods
    addExternalEmail() {
        this._elements.addExternalEmailField = this.wrapper.querySelector(this._selectors.addExternalEmailField);
        this._elements.addExternalEmailExpField = this.wrapper.querySelector(this._selectors.addExternalEmailExpField);
        this._elements.addExternalEmailReasonField = this.wrapper.querySelector(
            this._selectors.addExternalEmailReasonField
        );

        let valid = true;
        valid = valid && this.checkEmail(this._elements.addExternalEmailField);
        valid = valid && this.checkExpirationDays(this._elements.addExternalEmailExpField);
        valid = valid && this.checkReason(this._elements.addExternalEmailReasonField);

        if (valid) {
            const url =
                '/pb/widgets/ux3/DevicePairingManagementController/addExternalEmail?widgetId=' +
                this._widgetId +
                '&pbContext=' +
                this._pageContext;
            $.get(url, {
                serviceName: this._serviceName,
                email: this._elements.addExternalEmailField.value,
                daysToExpiration: this._elements.addExternalEmailExpField.value,
                reason: this._elements.addExternalEmailReasonField.value,
                antiForgeryToken: this._antiForgeryToken,
            })
                .done(html => {
                    // check if the response html is not an error page
                    if (html.indexOf('externalEmailError') === -1) {
                        $(this._selectors.accordionTable).html(html);
                        $(this._selectors.accordionTable).trigger('update');
                        this.accTable.init();
                        this.disableActionButtons();
                        this.accTablePagination.buildPagination();
                        this.clearFilters();
                    } else {
                        // error trying to add external email
                        this.displayErrorDialog(html);
                    }
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    this.displayErrorDialog(errorThrown);
                });
            this._elements.externalEmailDialog.modal('toggle');
        }
    }

    extendReinstateEmail() {
        this._elements.extendReinstateEmailField = this.wrapper.querySelector(
            this._selectors.extendReinstateEmailField
        );
        this._elements.extendReinstateExpDaysField = this.wrapper.querySelector(
            this._selectors.extendReinstateExpDaysField
        );
        this._elements.extendReinstateReasonField = this.wrapper.querySelector(
            this._selectors.extendReinstateReasonField
        );
        this._elements.checkedEmailFilterRadios = this.wrapper.querySelector(this._selectors.checkedEmailFilterRadios);
        this._elements.checkedPermissionFilterRadios = this.wrapper.querySelector(
            this._selectors.checkedPermissionFilterRadios
        );
        let valid = true;
        valid = valid && this.checkExpirationDays(this._elements.extendReinstateExpDaysField);
        valid = valid && this.checkReason(this._elements.extendReinstateReasonField);

        const selectedEmail = this._elements.extendReinstateEmailField.value;

        if (valid) {
            const url =
                '/pb/widgets/ux3/DevicePairingManagementController/extendReinstateEmail?widgetId=' +
                this._widgetId +
                '&pbContext=' +
                this._pageContext;
            $.get(url, {
                serviceName: this._serviceName,
                extendReinstateEmail: selectedEmail,
                daysToExpiration: this._elements.extendReinstateExpDaysField.value,
                reason: this._elements.extendReinstateReasonField.value,

                // need to send the current filter options as well, so that we maintain the same filters
                emailFilter: this._elements.checkedEmailFilterRadios.getAttribute('id'),
                permissionFilter: this._elements.checkedPermissionFilterRadios.getAttribute('id'),
                emailAddress: this._elements.emailAddressInput.value,
                name: this._elements.nameInput.value,
                fromDate: this.convertDateFormat(this._elements.fromDateField.value),
                toDate: this.convertDateFormat(this._elements.toDateField.value),
                antiForgeryToken: this._antiForgeryToken,
            })
                .done(html => {
                    $(this._selectors.accordionTable).html(html);
                    $(this._selectors.accordionTable).trigger('update');
                    this.accTable.init();
                    this.accTablePagination.buildPagination();
                    this.wrapper
                        .querySelector('input[value=' + "'" + selectedEmail + "'" + ']')
                        .setAttribute('checked', true);
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    this.displayErrorDialog(errorThrown);
                });
            this._elements.extendReinstateAccessDialog.modal('toggle');
        }
    }

    revokeEmail() {
        this._elements.revokeEmailField = this.wrapper.querySelector(this._selectors.revokeEmailField);
        this._elements.revokeReasonField = this.wrapper.querySelector(this._selectors.revokeReasonField);
        this._elements.extendReinstateReasonField = this.wrapper.querySelector(
            this._selectors.extendReinstateReasonField
        );

        const selectedEmail = this._elements.revokeEmailField.value;
        const url =
            '/pb/widgets/ux3/DevicePairingManagementController/revokeAccess?widgetId=' +
            this._widgetId +
            '&pbContext=' +
            this._pageContext;
        $.get(url, {
            serviceName: this._serviceName,
            revokeEmail: selectedEmail,
            reason: this._elements.extendReinstateReasonField.value,

            // need to send the current filter options as well, so that we maintain the same filters
            emailFilter: this._elements.checkedEmailFilterRadios.getAttribute('id'),
            permissionFilter: this._elements.checkedPermissionFilterRadios.getAttribute('id'),
            emailAddress: this._elements.emailAddressInput.value,
            name: this._elements.nameInput.value,
            fromDate: this.convertDateFormat(this._elements.fromDateField.value),
            toDate: this.convertDateFormat(this._elements.toDateField.value),
            antiForgeryToken: this._antiForgeryToken,
        })
            .done(html => {
                $(this._selectors.accordionTable).html(html);
                $(this._selectors.accordionTable).trigger('update');
                this.accTable.init();
                this.accTablePagination.buildPagination();
                this.wrapper
                    .querySelector('input[value=' + "'" + selectedEmail + "'" + ']')
                    .setAttribute('checked', true);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                this.displayErrorDialog(errorThrown);
            });
        this._elements.revokeAccessDialog.modal('toggle');
    }

    refreshPairedDevices() {
        this._elements.checkedEmailFilterRadios = this.wrapper.querySelector(this._selectors.checkedEmailFilterRadios);
        this._elements.checkedPermissionFilterRadios = this.wrapper.querySelector(
            this._selectors.checkedPermissionFilterRadios
        );
        const url =
            '/pb/widgets/ux3/DevicePairingManagementController/institutionPairedDevices?widgetId=' +
            this._widgetId +
            '&pbContext=' +
            this._pageContext;
        $.get(url, {
            serviceName: this._serviceName,
            emailFilter: this._elements.checkedEmailFilterRadios.getAttribute('id'),
            permissionFilter: this._elements.checkedPermissionFilterRadios.getAttribute('id'),
            emailAddress: this._elements.emailAddressInput.value,
            name: this._elements.nameInput.value,
            fromDate: this.convertDateFormat(this._elements.fromDateField.value),
            toDate: this.convertDateFormat(this._elements.toDateField.value),
        })
            .done(html => {
                $(this._selectors.accordionTable).html(html);
                $(this._selectors.accordionTable).trigger('update');
                this.disableActionButtons();
                this.accTable.init();
                this.accTablePagination.buildPagination();
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                this.displayErrorDialog(errorThrown);
            });
    }

    // Selected action checks
    /*
     * validate expiration days to ensure it is an integer
     */
    checkExpirationDays(expirationDaysField) {
        var intRegex = /^\d+$/;
        if (!intRegex.test(expirationDaysField.value)) {
            expirationDaysField.classList.add(this._classList.isInvalid);
            expirationDaysField.parentElement.querySelector(this._selectors.invalidFeedback).style.display = '';
            return false;
        }
        expirationDaysField.classList.remove(this._classList.isInvalid);
        expirationDaysField.parentElement.querySelector(this._selectors.invalidFeedback).style.display = 'none';
        return true;
    }

    /*
     * ensure reason field has text
     */
    checkReason(reasonField) {
        const invalidEl = reasonField.parentElement.querySelector(this._selectors.invalidFeedback);
        if (!reasonField.value) {
            reasonField.classList.add(this._classList.isInvalid);
            if (invalidEl) {
                invalidEl.style.display = '';
            }
            return false;
        }
        reasonField.classList.remove(this._classList.isInvalid);
        if (invalidEl) {
            invalidEl.style.display = 'none';
        }
        return true;
    }

    /*
     * ensure email field isn't empty
     */
    checkEmail(emailField) {
        const invalidEl = emailField.parentElement.querySelector(this._selectors.invalidFeedback);
        if (!emailField.value || emailField.value.trim().length === 0) {
            emailField.classList.add(this._classList.isInvalid);
            if (invalidEl) {
                invalidEl.style.display = '';
            }
            emailField.parentElement.querySelector(this._selectors.invalidFeedback).style.display = '';
            return false;
        }
        emailField.classList.remove(this._classList.isInvalid);
        if (invalidEl) {
            invalidEl.style.display = '';
        }
        return true;
    }

    /*
     * ensure dates are valid
     */
    checkDates() {
        const fromField = this._elements.fromDateField;
        const fromValue = fromField.value;
        const fromInvalidFeedback = this._elements.fromDateFeedback;
        const toField = this._elements.toDateField;
        const toValue = toField.value;
        const toInvalidFeedback = this._elements.toDateFeedback;
        if (!fromValue || !toValue) {
            if (!fromValue) {
                fromField.classList.add(this._classList.isInvalid);
                fromInvalidFeedback.style.display = '';
            }
            if (!toValue) {
                toField.classList.add(this._classList.isInvalid);
                toInvalidFeedback.style.display = '';
            }
            this._elements.refreshButton.setAttribute('disabled', true);
            return false;
        } else if (fromValue > toValue || toValue < fromValue) {
            fromField.classList.add(this._classList.isInvalid);
            fromInvalidFeedback.style.display = '';
            toField.classList.add(this._classList.isInvalid);
            toInvalidFeedback.style.display = '';
            this._elements.refreshButton.setAttribute('disabled', true);
            return false;
        }
        fromField.classList.remove(this._classList.isInvalid);
        toField.classList.remove(this._classList.isInvalid);
        fromInvalidFeedback.style.display = 'none';
        toInvalidFeedback.style.display = 'none';
        this._elements.refreshButton.removeAttribute('disabled');
        return true;
    }

    // Clear methods
    /*
     * clear dialog data
     */
    clearDialog($dialog) {
        $dialog.find('input').removeClass(this._classList.isInvalid).val('');
        $dialog.find(this._selectors.expDays).val('180');
    }

    /*
     * clear filters data
     */
    clearFilters() {
        // reset email filter
        this._elements.emailFilterRadios[0].click();
        // reset permission filter
        this._elements.permissionFilterRadios[1].click();
        // reset the text input filters
        this._elements.emailAddressInput.value = '';
        this._elements.nameInput.value = '';
    }

    disableActionButtons() {
        this._elements.extendReinstateButton.setAttribute('disabled', true);
        this._elements.revokeButton.setAttribute('disabled', true);
        this._elements.viewDetailButton.setAttribute('disabled', true);
        this._elements.withSelected.setAttribute('disabled', true);
    }

    enableActionButtons(e) {
        this._elements.checkedUserEmail = e.target;
        this._elements.extendReinstateButton.removeAttribute('disabled');
        this._elements.revokeButton.removeAttribute('disabled');
        this._elements.viewDetailButton.removeAttribute('disabled');
        this._elements.withSelected.removeAttribute('disabled');
    }

    /*
     * Converts default date input format which is yyyy-mm-dd into mm/dd/yyyy
     */
    convertDateFormat(dateString) {
        const year = dateString.substring(0, dateString.indexOf('-'));
        const month = dateString.substring(dateString.indexOf('-') + 1, dateString.lastIndexOf('-'));
        const day = dateString.substring(dateString.lastIndexOf('-') + 1, dateString.length);
        return `${month}/${day}/${year}`;
    }

    /*
     * error to display when any of the apis fail
     */
    displayErrorDialog(message) {
        this._elements.externalEmailError.find('.message').html(this._serverErrMsgPrefix + message);
        this._elements.externalEmailError.modal('toggle');
    }
}
